import { ACTION_TYPES } from '../../utils/Constants';

export const clearChatMessages = () => {
    return {
        type: ACTION_TYPES.STUDENT.CLEAR_CHAT_MESSAGES_LIST,
    };
};
